export const GET_ALL_RESOURCES_TYPES = 'GET_ALL_RESOURCES_TYPES';